module.exports = new __parcel__URL__("pineapple.61ebb967.svg").toString();